import React, { useState } from "react";
import { X } from "lucide-react";
import { Vehicle } from "../../pages/Fleet-management/FleetManagementPage";

const BRAND = "#143887";
const BRAND_LIGHT = "#1438871A";

const drivers = ["Kehinde Stephanie", "Peniel", "Charly", "Onyeto", "Donn", "Charles", "Odogwu", "Temi", "Hero"];

interface Props {
  vehicles: Vehicle[];
  onClose: () => void;
}

export default function AssignDriverModal({ vehicles, onClose }: Props) {
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [selectedDriver, setSelectedDriver] = useState("");
  const [showVehicleDropdown, setShowVehicleDropdown] = useState(false);
  const [showDriverDropdown, setShowDriverDropdown] = useState(false);

  const handleAssign = () => {
    if (!selectedVehicle || !selectedDriver) return;
    console.log("Assigning", selectedDriver, "to", selectedVehicle);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <p className="text-sm font-semibold text-gray-700">Assignment</p>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <X size={18} className="text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6 space-y-5">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-full flex items-center justify-center" style={{ background: BRAND_LIGHT }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="8" r="4" stroke={BRAND} strokeWidth="1.5" />
                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={BRAND} strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <p className="font-semibold text-gray-800">Assign Driver</p>
          </div>

          {/* Vehicle selector */}
          <div>
            <label className="text-xs text-gray-500 mb-1.5 block">Vehicle</label>
            <div className="relative">
              <button
                onClick={() => { setShowVehicleDropdown(!showVehicleDropdown); setShowDriverDropdown(false); }}
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-left flex items-center justify-between focus:outline-none focus:border-blue-300"
              >
                <span className={selectedVehicle ? "text-gray-800" : "text-gray-400"}>
                  {selectedVehicle || "Select vehicle"}
                </span>
                <span className="text-gray-400">▾</span>
              </button>
              {showVehicleDropdown && (
                <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 z-10 shadow-lg max-h-48 overflow-y-auto">
                  {vehicles.map((v, i) => (
                    <button
                      key={i}
                      onClick={() => { setSelectedVehicle(`${v.make} ${v.model} ${v.year}`); setShowVehicleDropdown(false); }}
                      className="w-full text-left px-3 py-2.5 text-sm hover:bg-gray-50 border-b border-gray-50 last:border-0"
                    >
                      {v.make} {v.model} {v.year}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Driver selector */}
          <div>
            <label className="text-xs text-gray-500 mb-1.5 block">Assign Driver</label>
            <div className="relative">
              <button
                onClick={() => { setShowDriverDropdown(!showDriverDropdown); setShowVehicleDropdown(false); }}
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-left flex items-center justify-between focus:outline-none focus:border-blue-300"
              >
                <span className={selectedDriver ? "text-gray-800" : "text-gray-400"}>
                  {selectedDriver || "Select driver"}
                </span>
                <span className="text-gray-400">▾</span>
              </button>
              {showDriverDropdown && (
                <div className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg mt-1 z-10 shadow-lg max-h-48 overflow-y-auto">
                  {drivers.map((d) => (
                    <button
                      key={d}
                      onClick={() => { setSelectedDriver(d); setShowDriverDropdown(false); }}
                      className="w-full text-left px-3 py-2.5 text-sm hover:bg-gray-50 border-b border-gray-50 last:border-0"
                    >
                      {d}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 pb-6">
          <button
            onClick={handleAssign}
            disabled={!selectedVehicle || !selectedDriver}
            className="w-full py-2.5 rounded-lg text-white text-sm font-medium transition-opacity hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
            style={{ background: BRAND }}
          >
            Assign Driver
          </button>
        </div>
      </div>
    </div>
  );
}